/* esm.sh - applesauce-content@6.0.0/text */
export * from "/*applesauce-content@6.0.0/esnext/text.mjs";
